module.exports = __webpack_public_path__ + "static/img/Ginbey.1694cdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ginbey.jpg
// module id = SPIH
// module chunks = 0